module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (9).59cb4e87.jpg";